export default function CScope() {
  return <h2>C Scope</h2>;
}
